import { render, staticRenderFns } from "./DeliveryNotesPanel.vue?vue&type=template&id=939e674a&scoped=true"
import script from "./DeliveryNotesPanel.vue?vue&type=script&lang=js"
export * from "./DeliveryNotesPanel.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNotesPanel.vue?vue&type=style&index=0&id=939e674a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939e674a",
  null
  
)

export default component.exports